// extracted by mini-css-extract-plugin
export default {"add-portfolio":"style_add-portfolio__r1E18","edit":"style_edit__34-wC","add":"style_add__wAKWy","overview":"style_overview__gVtXG"};